<tt-page *ngIf="page">
    <tt-grid *ngIf="grid" [ttOptions]="grid">
        <ng-container toolbarButtons>
            <tt-button ttText="add" ttIcon="fas fa-plus" [ttLoading]="editing" (ttClick)="addRow()"></tt-button>
        </ng-container>
    </tt-grid>
    <tt-card *ngIf="newCustomer" class="col-xs-12 sp-5">
        <tt-button ttText="goto_customers" (ttClick)="goToCustomers()" ttTextAlign="center"></tt-button>
        <tt-button ttText="goto_new_customer" (ttClick)="goToNewCustomer()" ttTextAlign="center"></tt-button>
    </tt-card>
</tt-page>
